import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import {
  getSaleOrderBranch,
  getSaleOrderBranchById,
  getParticularPage,
  getNext,
  getPrevious,
  handleSearch,
  getSaleOrderBranchAdditionalChargeList,
  createSaleOrderBranch,
  convertToSaleInvoice,
} from "./thunk";
import { NepaliDate } from "@zener/nepali-datepicker-react";
import { dateFormater } from "../../../../../../Utils/dateFormater";
import { materialRequestsFrom } from "../../../../../../Utils/constants";

const initialState = {
  saleOrderBranchs: [],
  edit: false,
  saleOrderBranch: null,
  count: 0,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingCreate: false,
  loadingUpdated: false,
  loadingSaleOrderBranch: false,
  loadingNext: false,
  saveAndContinue: false,
  saleOrderBranchDetails: [
    {
      product: null,
      vendor: null,
      closingStock: "",
      description: "",
      actualQuantity: "",
      unit: "",
      altQuantity: "",
      altUnit: null,
      rate: "",
      amount: "",
      requiredDate: dateFormater(new NepaliDate()),
      unique: uuidv4(),
    },
  ],
  additionalCharges: null,
  showCreateModal: false, // ✅ Add this
  formData: {
    partyAccount: null,
    indentNo: "",
    isFromHo: materialRequestsFrom[0],
    voucherDateBs: new NepaliDate(),
    receiverBranch: null,
    branch: null,
    placeOfSupply: "",
    narration: "",
    discountAmount: "",
    grandTotal: "",
    vatAmount: "",
    documentsAttach: [],
    refVoucher: "",
    termsOfDelivery: "",
    deliveryDocNo: "",
    otherReferences: "",
    destination: "",

    termOfPayment: null,
    salesOrderMainVehicleDetail: {
      vehicleNo: "",
      builtyNo: "",
      driverName: "",
      driverPhoneNo: "",
      driverAddress: "",
      licenseNo: "",
      transporter: "",
      quantity: "",
    },
    salesOrderMainPartyDetails: {
      creditDays: "",
      jobNumber: "",
      deliveryDate: "",
      validDays: "",
      billingAddress: null,
      shippingAddress: null,
    },
  },
  oldSaleOrderBranchDetails: [],
};

export const saleOrderBranchSlice = createSlice({
  name: "saleOrderBranch",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    setSaveAndContinue: (state, { payload }) => {
      state.saveAndContinue = payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    saleOrderBranchDetailsUpdated: (state, action) => {
      const sam = action.payload?.reduce((acc, pos) => {
        return Number(pos.actualQuantity) + acc;
      }, 0);
      state.saleOrderBranchDetails = action.payload;
      state.additionalCharges = state.additionalCharges.map((value) => {
        return { ...value, amount: value.canEdit ? value.rate * sam : value.amount };
      });
    },
    updatedAdditionalCharges: (state, action) => {
      state.additionalCharges = action.payload;
    },
    clearSaleOrderBranchDetails: (state) => {
      state.saleOrderBranchDetails = [
        {
          product: null,
          vendor: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          unit: "",
          altQuantity: "",
          altUnit: null,
          rate: "",
          amount: "",
          requiredDate: dateFormater(new NepaliDate()),
          unique: uuidv4(),
        },
      ];
    },
    clearAllSaleOrderBranch: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingSaleOrderBranch = false;
      state.saleOrderBranch = null;
      state.saveAndContinue = false;
      state.saleOrderBranchDetails = [
        {
          product: null,
          vendor: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          unit: "",
          altQuantity: "",
          altUnit: null,
          rate: "",
          amount: "",
          requiredDate: dateFormater(new NepaliDate()),
          unique: uuidv4(),
        },
      ];
      state.additionalCharges = null;
      state.formData = initialState.formData;
      state.oldSaleOrderRequestDetails = initialState.oldSaleOrderBranchDetails;
    },
    saveSaleOrderBranchForm: (state, action) => {
      state.formData = action.payload;
    },
    resetSaleOrderBranchForm: (state, action) => {
      if (action.payload) {
        state.formData = state.saleOrderBranch;
        state.saleOrderBranchDetails = state.oldSaleOrderBranchDetails;
      } else {
        state.formData = initialState.formData;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSaleOrderBranchAdditionalChargeList.pending, (state) => {
      state.additionalCharges = null;
    });
    builder.addCase(getSaleOrderBranchAdditionalChargeList.fulfilled, (state, action) => {
      state.additionalCharges = action.payload.data;
    });
    builder.addCase(getSaleOrderBranchAdditionalChargeList.rejected, (state) => {
      state.additionalCharges = null;
    });

    // getSaleOrderBranchById
    builder.addCase(getSaleOrderBranchById.pending, (state) => {
      state.loading = true;
      state.saleOrderBranch = null;
    });
    builder.addCase(getSaleOrderBranchById.fulfilled, (state, action) => {
      const saleOrderBranch = action.payload.data;

      const transformedFormData = {
        ...saleOrderBranch,
        partyAccount: saleOrderBranch ? saleOrderBranch?.partyAccount : null,
        indentNo: saleOrderBranch?.voucherNo,
        isFromHo: materialRequestsFrom[1],

        voucherDateBs: new NepaliDate(),
        receiverBranch: saleOrderBranch ? saleOrderBranch?.receiverBranch : null,
        branch: saleOrderBranch ? saleOrderBranch?.branch : null,
        placeOfSupply: saleOrderBranch.purchaseOrder ? saleOrderBranch?.purchaseOrder.placeOfSupply : "",
        narration: saleOrderBranch.purchaseOrder ? saleOrderBranch?.purchaseOrder.narration : "",
        discountAmount: "",
        grandTotal: "",
        vatAmount: "",
        documentsAttach: [],
        refVoucher: saleOrderBranch ? saleOrderBranch?.refVoucher : "",
        termsOfDelivery: saleOrderBranch?.termsOfDelivery,
        deliveryDocNo: saleOrderBranch?.deliveryDocNo,
        otherReferences: "",
        destination: saleOrderBranch?.destination,

        termOfPayment: saleOrderBranch?.termOfPayment,
        salesOrderMainVehicleDetail: {
          vehicleNo: "",
          builtyNo: "",
          driverName: "",
          driverPhoneNo: "",
          driverAddress: "",
          licenseNo: "",
          transporter: "",
          quantity: "",
        },
        salesOrderMainPartyDetails: {
          creditDays: "",
          jobNumber: "",
          deliveryDate: "",
          validDays: "",
          billingAddress: null,
          shippingAddress: null,
        },
      };

      const transformedDetails = [
        ...action.payload.data?.saleOrderDetails.map((value) => ({
          ...value,
          unique: uuidv4(),
        })),
        {
          unique: uuidv4(),
          actualQuantity: "",
          altUnit: null,
          altQuantity: "",
          amount: "",
          closingStock: "",
          description: "",
          product: null,
          rate: "",
          requiredDateAd: dateFormater(new NepaliDate().toADasDate()),
          unit: "",
        },
      ];
      state.edit = true;
      state.loading = false;
      state.saleOrderBranch = transformedFormData;
      state.saleOrderBranchDetails = transformedDetails;
      state.additionalCharges =
        action.payload.data?.salesOrderMainAdditionalChargeCost.length > 0
          ? action.payload.data?.salesOrderMainAdditionalChargeCost
          : null;

      state.oldSaleOrderBranchDetails = transformedDetails;
      state.formData = transformedFormData;
    });
    builder.addCase(getSaleOrderBranchById.rejected, (state) => {
      state.edit = false;
      state.loading = false;
      state.saleOrderBranch = null;
    });

    builder.addMatcher(
      isAnyOf(
        getSaleOrderBranch.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingSaleOrderBranch = true;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getSaleOrderBranch.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingSaleOrderBranch = false;
        state.saleOrderBranchs = action.payload.data;
        state.count = action.payload.totalCount;
        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getSaleOrderBranch.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingSaleOrderBranch = false;
      }
    );
    builder.addMatcher(isAnyOf(createSaleOrderBranch.pending, convertToSaleInvoice.pending), (state) => {
      state.loadingCreate = true;
    });
    builder.addMatcher(isAnyOf(createSaleOrderBranch.fulfilled, convertToSaleInvoice.fulfilled), (state, action) => {
      state.loadingCreate = false;
    });
    builder.addMatcher(isAnyOf(createSaleOrderBranch.rejected, convertToSaleInvoice.rejected), (state) => {
      state.loadingCreate = false;
    });
  },
});

export const {
  setShowCreateModal,
  setSaveAndContinue,
  goToPage,
  saleOrderBranchDetailsUpdated,
  updatedAdditionalCharges,
  clearSaleOrderBranchDetails,
  clearAllSaleOrderBranch,
  saveSaleOrderBranchForm,
  resetSaleOrderBranchForm,
} = saleOrderBranchSlice.actions;

export default saleOrderBranchSlice.reducer;
